// The stadium photo behind the Pick Three card and page header. Null gives the
// plain navy gradient.
//
// Source and licence: see src/assets/games/pick-three-credit.txt. Any photo
// used here needs a clear licence, no readable school name or logo, and no
// recognisable faces. It ships in the app bundle, so keep it near 150KB.
// Text sits on a dark scrim (PickThreeBackdrop), so any photo that is not
// mostly white works.
import art from "../assets/games/pick-three.jpg";

export default art;
